import { render, staticRenderFns } from "./generic-modal.vue?vue&type=template&id=6afc14cf"
import script from "./generic-modal.vue?vue&type=script&lang=js"
export * from "./generic-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports